import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";

interface ToggleProps {
  checked: boolean;
  disabled: boolean;
  size?: "default" | "medium" | "small";
}

const getWrapperWidth = (size: ToggleProps["size"]) => {
  if (size === "small") return "24px";
  if (size === "medium") return "32px";
  return "40px";
};

const getWrapperHeight = (size: ToggleProps["size"]) => {
  if (size === "small") return "24px";
  if (size === "medium") return "32px";
  return "40px";
};

const getWrapperPadding = (size: ToggleProps["size"]) => {
  if (size === "small") return "6px 2px";
  if (size === "medium") return "8px 2px";
  return "10px 3px";
};

const getSliderWidth = (size: ToggleProps["size"]) => {
  if (size === "small") return "20px";
  if (size === "medium") return "28px";
  return "34px";
};

const getSliderHeight = (size: ToggleProps["size"]) => {
  if (size === "small") return "12px";
  if (size === "medium") return "16px";
  return "20px";
};

const getSliderBorderRadius = (size: ToggleProps["size"]) => {
  if (size === "small") return "6px";
  if (size === "medium") return "8px";
  return "10px";
};

const getHandleSize = (size: ToggleProps["size"]) => {
  if (size === "small") return "8px";
  if (size === "medium") return "12px";
  return "14px";
};

const getHandleTranslateX = (size: ToggleProps["size"]) => {
  if (size === "small") return "8px";
  if (size === "medium") return "12px";
  return "14px";
};

const getBackgroundColor = (checked: boolean, disabled: boolean) => {
  if (checked) {
    return disabled
      ? colorGuide.lightComponents.toggleButton.checked.disabled.backgroundColor
      : colorGuide.lightComponents.toggleButton.checked.enabled.backgroundColor;
  } else {
    return disabled
      ? colorGuide.lightComponents.toggleButton.unchecked.disabled
          .backgroundColor
      : colorGuide.lightComponents.toggleButton.unchecked.enabled
          .backgroundColor;
  }
};

const getToggleColor = (checked: boolean, disabled: boolean) => {
  if (checked) {
    return disabled
      ? colorGuide.lightComponents.toggleButton.checked.disabled
          .toggleBackgroundColor
      : colorGuide.lightComponents.toggleButton.checked.enabled
          .toggleBackgroundColor;
  } else {
    return disabled
      ? colorGuide.lightComponents.toggleButton.unchecked.disabled
          .toggleBackgroundColor
      : colorGuide.lightComponents.toggleButton.unchecked.enabled
          .toggleBackgroundColor;
  }
};

export const ToggleWrapper = styled.div<ToggleProps>`
  display: flex;
  width: ${({ size }) => getWrapperWidth(size)};
  height: ${({ size }) => getWrapperHeight(size)};
  padding: ${({ size }) => getWrapperPadding(size)};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
`;

export const ToggleSlider = styled.div<ToggleProps>`
  width: ${({ size }) => getSliderWidth(size)};
  height: ${({ size }) => getSliderHeight(size)};
  background-color: ${({ checked, disabled }) =>
    getBackgroundColor(checked, disabled)};
  border-radius: ${({ size }) => getSliderBorderRadius(size)};
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
  padding: 0 2px;
  cursor: ${({ disabled }) => (disabled ? "" : "pointer")};
`;

export const ToggleHandle = styled.div<ToggleProps>`
  width: ${({ size }) => getHandleSize(size)};
  height: ${({ size }) => getHandleSize(size)};
  background-color: ${({ checked, disabled }) =>
    getToggleColor(checked, disabled)};
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  transform: ${({ checked, size }) =>
    checked ? `translateX(${getHandleTranslateX(size)})` : "translateX(0)"};
`;
